import React, {Component} from 'react';
import marketStyle from '../css/marketsCricket.css';
import OddsCardCricket from './oddsCardCricket';
import {FIRST_TEAM_RUNS_OFF_FIRST_BALL} from "../constants/marketTypes";
import { getText } from '../../../../../helpers/localization';

class FirstTeamRunsOffFirstBall extends Component {
    render() {
        let markets = this.props.markets;
        let store = this.props.store;
        let scoreGroupStyle = markets[0].code === Number(FIRST_TEAM_RUNS_OFF_FIRST_BALL.code) ? marketStyle.scoreGroupSmall : marketStyle.scoreGroup

        let totalGoalsMarkets = markets.map((market, index) => {
            return (
                <div className={`${scoreGroupStyle}`} key={index}>
                    <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                        <span>{ markets[0].code === Number(FIRST_TEAM_RUNS_OFF_FIRST_BALL.code) ? market.selection : getText(market.selection, this.props.store)}</span>
                    </div>
                    <div className={marketStyle.oddsContainer}>
                        <OddsCardCricket store={store} market={market}/>
                    </div>
                </div>
            );
        });

        return (<div className={`${marketStyle.marketGroup} ${marketStyle.marketAlignFlex}`}>{totalGoalsMarkets}</div>);
    }
}

export default FirstTeamRunsOffFirstBall;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/cricket/components/firstTeamRunsOffFirstBall.js